import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './Navigation';
import Home from './home';
import Placas from './placas';
import PlacasLead from './placaslead';
import ClubLead from './clublead';
import Regras from './regras';
import Contato from './contato';
import './styler.css'; // Importe o arquivo de estilos CSS

function App() {
  return (
      <Router>
          <Navigation />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/placas" element={<Placas />} />
            <Route path="/regras" element={<Regras />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/placaslead" element={<PlacasLead />} />
            <Route path="/clublead" element={<ClubLead />} />
        </Routes>
      </Router>
  );
}

export default App;
